import { observer } from "mobx-react";
import RmaListFiltersStore from "../../../stores/rma-list-filters-store";
import { IOption, SelectDropdown } from "../../../../../../components/inputs/select-dropdown/select-dropdown";
import { SingleValue } from "react-select";
import { RESERVED_ITEM_EXPIRATION_TYPE } from "../../../../../../services/api/rma-list-service";
import {
    MANAGE_RETURNS_DESIGN_VERSION,
    trackManageReturnsListEvent,
} from "../../../../utils/manage-returns-list-mixpanel";
import ReserverdItemsDaysRemainingInput from "./reserved-item-days-remaining-inputs";
import { IValidationGroup } from "../../../../../../hooks/validation-group/validation-group-hook";
import ReserverdItemsDateRangeInput from "./reserved-item-date-range-input";

interface IProps {
    rmaListFiltersStore: RmaListFiltersStore;
    validationGroup: IValidationGroup;
}

const ReservedItemExpirationDropdown: React.FC<IProps> = observer(({ rmaListFiltersStore, validationGroup }) => {
    const onSelectReservedItemExpiration = (value: SingleValue<IOption>) => {
        if (value?.value) {
            trackManageReturnsListEvent(
                "d&_filter_reserved_item_expiration",
                MANAGE_RETURNS_DESIGN_VERSION.V1,
            );
        }
        rmaListFiltersStore.setReserverdItemExpiration(value?.value as RESERVED_ITEM_EXPIRATION_TYPE);
        rmaListFiltersStore.setReserverdItemExpirationInput(undefined);
    };

    return (
        <>
            <SelectDropdown
                isLoading={rmaListFiltersStore.isLoading}
                options={rmaListFiltersStore.reserverdItemExpirationOptions}
                value={rmaListFiltersStore.reserverdItemExpirationValue}
                onChange={onSelectReservedItemExpiration}
            />
            {rmaListFiltersStore.reserveItemExpiration === RESERVED_ITEM_EXPIRATION_TYPE.DATE_RANGE && (
                <ReserverdItemsDateRangeInput rmaListFiltersStore={rmaListFiltersStore} />
            )}
            {rmaListFiltersStore.reserveItemExpiration === RESERVED_ITEM_EXPIRATION_TYPE.DAYS_REMAINING && (
                <ReserverdItemsDaysRemainingInput
                    store={rmaListFiltersStore.reservedItemDaysRemainingStore}
                    validationGroup={validationGroup}
                />
            )}
        </>

    );
});

export default ReservedItemExpirationDropdown;
